// extracted by mini-css-extract-plugin
export var backdropBlur = "_l4-0";
export var contentCard = "_l4-5";
export var frame = "_l4-2";
export var image = "_l4-4";
export var imagePane = "_l4-3";
export var modal = "_l4-1";